
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.379 22.927l2.612-3.319a.932.932 0 011.465 0l2.611 3.319M14.21 20.401l2.978-3.783a.932.932 0 011.465 0l4.983 6.288","stroke":"#333","stroke-width":"1.3","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M11.515 16.434a1.204 1.204 0 100-2.408 1.204 1.204 0 000 2.408zM16.305 17.738c.458.27.94.566.94.566l.676-.457.576.42.942-.652","stroke":"#333","stroke-width":"1.3","stroke-miterlimit":"10","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M23.504 12.17H8.703a.69.69 0 00-.69.691v9.375c0 .381.309.69.69.69h14.8a.69.69 0 00.691-.69v-9.375a.69.69 0 00-.69-.69z","stroke":"#333","stroke-width":"1.3","stroke-miterlimit":"10","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M27.272 8.846H4.728C3.774 8.846 3 9.62 3 10.575v13.578c0 .954.774 1.728 1.728 1.728h22.544c.954 0 1.728-.774 1.728-1.728V10.575c0-.955-.774-1.729-1.728-1.729z","stroke":"#333","stroke-width":"1.3","stroke-miterlimit":"10","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M29 11.208V6.482a1.793 1.793 0 00-1.792-1.793H16.959a1.792 1.792 0 01-1.492-.797l-.727-1.094A1.793 1.793 0 0013.248 2H4.793A1.792 1.792 0 003 3.792v7.416","stroke":"#333","stroke-width":"1.3","stroke-miterlimit":"10","stroke-linecap":"round"}})])
          )
        }
      }
    